var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import sugar from 'sugar';

var sortArrayByDate = function sortArrayByDate(arr, inverseSort) {
    return arr.sort(function (a, b) {
        return inverseSort ? sugar.Date.create(b) - sugar.Date.create(a) : sugar.Date.create(a) - sugar.Date.create(b);
    });
};

var sortObjArrayByDate = function sortObjArrayByDate(arr, inverseSort, dateField) {
    return arr.sort(function (a, b) {
        return inverseSort ? sugar.Date.create(b[dateField]) - sugar.Date.create(a[dateField]) : sugar.Date.create(a[dateField]) - sugar.Date.create(b[dateField]);
    });
};

var sortByValue = function sortByValue(arr, inverseSort, isCategories) {
    if (arr.every(function (x) {
        return typeof x === 'number';
    })) return inverseSort && !isCategories ? arr.sort(function (a, b) {
        return a - b;
    }).reverse() : arr.sort(function (a, b) {
        return a - b;
    });

    return arr.sort(function (value1, value2) {
        var pattern = new RegExp("^[0-9]{1,2}[-/\][0-9]{2,4}$");
        var oneDigitPrefix = new RegExp("^[0-9]{1}[-/\][0-9]{2,4}$");

        if (pattern.test(value1) && oneDigitPrefix.test(value1)) {
            var tempValue1 = value1.split(new RegExp("[-/\]"));
            value1 = "0" + tempValue1[1] + "0" + tempValue1[0];
        }
        if (pattern.test(value2) && oneDigitPrefix.test(value2)) {
            var tempValue2 = value2.split(new RegExp("[-/\]"));
            value2 = "0" + tempValue2[1] + "0" + tempValue2[0];
        }

        if (value1 != null && value2 != null) return inverseSort && !isCategories ? value2.localeCompare(value1) : value1.localeCompare(value2);
    });
};

var sortObjArrayByValue = function sortObjArrayByValue(arr, inverseSort, fieldName) {
    //filter out nulls and check to see if remaining values are numbers
    if (arr.filter(function (x) {
        return x[fieldName] !== null;
    }).every(function (x) {
        return typeof x[fieldName] === 'number';
    }))
        //treat null values as 0, then sort by number
        return arr.map(function (x) {
            var _extends2;

            return x[fieldName] !== null ? x : _extends({}, x, (_extends2 = {}, _extends2[fieldName] = 0, _extends2));
        }).sort(function (a, b) {
            return inverseSort ? a[fieldName] - b[fieldName] : b[fieldName] - a[fieldName];
        });

    return arr.sort(function (a, b) {
        var pattern = new RegExp("^[0-9]{1,2}[-/\][0-9]{2,4}$");
        var oneDigitPrefix = new RegExp("^[0-9]{1}[-/\][0-9]{2,4}$");

        var value1 = a[fieldName];
        var value2 = b[fieldName];

        if (pattern.test(value1) && oneDigitPrefix.test(value1)) {
            var tempValue1 = value1.split(new RegExp("[-/\]"));
            value1 = "0" + tempValue1[1] + "0" + tempValue1[0];
        }
        if (pattern.test(value2) && oneDigitPrefix.test(value2)) {
            var tempValue2 = value2.split(new RegExp("[-/\]"));
            value2 = "0" + tempValue2[1] + "0" + tempValue2[0];
        }

        if (value1 != null && value2 != null && value1 != undefined && value2 != undefined) {
            return inverseSort ? value2.toString().localeCompare(value1.toString()) : value1.toString().localeCompare(value2.toString());
        }
    });
};

var sortBySortOrder = function sortBySortOrder(arr, orderField, inverseSort) {
    return arr.sort(function (a, b) {
        return inverseSort ? b[orderField] - a[orderField] : a[orderField] - b[orderField];
    });
};

export var sorter = {
    sortArrayByDate: sortArrayByDate,
    sortObjArrayByDate: sortObjArrayByDate,
    sortByValue: sortByValue,
    sortObjArrayByValue: sortObjArrayByValue,
    sortBySortOrder: sortBySortOrder
};